import classes from './Backdrop.module.css';

const Backdrop = (props) => {
    return <div className={`${classes.backdrop} ${props.over ? classes.backdrop_over : ''}`} onClick={props.hide}></div>
}

export default Backdrop;